var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.69998 0C15.0544 0 19.4 4.34559 19.4 9.69998C19.4 15.0544 15.0544 19.4 9.69998 19.4C4.34559 19.4 0 15.0544 0 9.69998C0 4.34559 4.34559 0 9.69998 0ZM9.69998 17.2444C13.8677 17.2444 17.2444 13.8677 17.2444 9.69998C17.2444 5.53115 13.8677 2.15555 9.69998 2.15555C5.53115 2.15555 2.15555 5.53115 2.15555 9.69998C2.15555 13.8677 5.53115 17.2444 9.69998 17.2444ZM18.8449 17.3209L21.8939 20.3689L20.3689 21.8939L17.3209 18.8449L18.8449 17.3209Z",
    fill: "#200E32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.ab369fc84c8bf257af5ec54c20e06887.svg";
export { ForwardRef as ReactComponent };